




import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { PropType, defineComponent, onMounted, ref, watch } from '@nuxtjs/composition-api';
import { Clinic } from '../types';

export default defineComponent({
  name: 'ClinicsGoogleMaps',
  components: {},
  props: {
    clinics: {
      type: Array as PropType<Clinic[]>,
    },
    mapOptions: {
      type: Object,
      default: () => ({
        // Stockholm coordinates
        center: {
          lat: 59.3293,
          lng: 18.0686,
        },
        zoom: 5,
      }),
    },
    height: {
      type: String,
      default: '720px',
    },
  },
  setup(props) {
    const mapElement = ref<HTMLDivElement | null>(null);
    let map = null;
    let markers = [];
    let Marker = null;
    let clusterer: MarkerClusterer = null;

    const createMarker = (googleMap, data, Marker) => {
      if (!data.latitude || !data.longitude) return null;
      const marker = new Marker({
        position: { lat: Number(data.latitude), lng: Number(data.longitude) },
        map: googleMap,
      });

      marker.addListener('click', () => {
        window.open(data.website as string, '_blank');
      });

      return marker;
    };

    const updateMarkers = () => {
      if (!Marker) return;

      if (clusterer) {
        clusterer.clearMarkers();
      }

      markers.forEach((marker) => {
        marker.setMap(null);
      });

      markers = (props.clinics || []).flatMap((data) => createMarker(map, data, Marker) ?? []);
      if (clusterer) {
        clusterer.addMarkers(markers);
      }
    };

    function onMapLoad() {
      if (!map) return
      clusterer = new MarkerClusterer({ map, markers: [] });
      updateMarkers();
    }

    onMounted(async () => {
      try {
        const loader = new Loader({
          apiKey: 'AIzaSyCzxgMPCfoL_Zhg3hP2T_yMhPOMqeWdZm0',
          version: 'weekly',
          libraries: ['places'],
        });
        const { Map } = await loader.importLibrary('maps');
        const markerLib = await loader.importLibrary('marker');
        const { event } = await loader.importLibrary("core");
        map = new Map(mapElement.value, props.mapOptions);
        Marker = markerLib.Marker;

        event.addListenerOnce(map, 'tilesloaded', function () {
          onMapLoad();
        });
      } catch (error) {
        console.log(error);
      }
    });

    watch(() => props.clinics, updateMarkers);

    return { mapElement };
  },
});
